import enLocale from 'element-ui/lib/locale/lang/en'
const msg = {
    ...enLocale,
    'Home':'Home',
    'Products':'Products',
    'Products Center':'Products',
    'News':'News',
    'News Updates':'News',
    'Our Department':'Our Department',
    'Keep In Touch':'Keep In Touch',
    'Tel':'Tel',
    'Email':'Email',
    'Address':'Address',
    'We\'d Love To Hear From You':'We\'d Love To Hear From You',
    'Last Name':'Last Name',
    'First Name':'First Name',
    'Telephone':'Telephone',
    'Country':'Country',
    'Additional Information':'Additional Information',
    'Submit':'Submit',
    'Contacts Us':'Contacts Us',
    'E-MAIL':'E-MAIL',
    'TEL':'TEL',
    'Previous':'Previous',
    'Next':'Next',
    'Latest News':'Latest News',
    'FTTx':'FTTx',
    'Data Center':'Data Center',
    'Customized':'Customized',
    'FTTx Solution':'FTTx Solution',
    'Data Center Solution':'Data Center Solution',
    'Customized Solution':'Customized Solution',
    'Specification':'Specification',
    'Ordering Information':'Ordering Information',
    'Requirement':'Customization & Ordering Options',
    'Product Highlights':'Product Highlights',
    'Related Products':'Related Products',
    关于我们:'About Us',
    解决方案:'Solution',
    产品中心:'Products',
    发展历程:'Milestone',
    公司简介:'Company Profile',
    组织架构:'Organizational Structure',
    我们的部门:'Our Department',
    荣誉资质:'Certificates and Honors',
    产品展示:'Our Products',
    查看更多:'View all',
    更多:'More',
    新闻资讯:'News',
    公司新闻:'Company News',
    行业新闻:'Industry News',
    联系我们:'Contact Us',
    产品分类:'Product Category',
    所有产品:'All Products',
    光纤连接器:'Fiber Connectors',
    光纤适配器:'Fiber Adapters',
    光纤衰减器:'Fiber Attenuators',
    光纤配线架:'Fiber ODF',
    其他产品:'Other Products',
    搜索:'Search',
    关闭:'Close',
    查看全部:'All',
    版权所有:'Copyrights © 2020 - ZHEJIANG JIAWEI COMMUNICATION',
    加载更多:'Load More',
    产品证书:'Certificates',
    '提交成功，我们会尽快与您联系！':'We will contact you soon!',
    '提交失败，请稍后重试':'Submit Failed, please try again later',
}
export default msg;
